import React from 'react';

const Ex1_Data = () => {
    return (
        <div>Ex1_Data Component</div>
    );
}

export default Ex1_Data;
